<script>
  import { onMount } from 'svelte';
  import { writable } from 'svelte/store';
  import * as uuid from 'uuid';
  import { useTooltips } from './TooltipRoot.svelte';
  import { browser } from '$app/environment';

  const addTooltip = useTooltips();
  const anchor$ = writable();

  export let testid = undefined;
  export let gravity = 'top';
  export let enabled = true;

  const tooltipid = uuid.v4();
  let container;
  let entry;
  let mounted = false;

  onMount(() => {
    const parent = container.parentNode;
    container.remove();
    mounted = true;
    entry = addTooltip(container, { anchor: anchor$, gravity });
    return () => {
      mounted = false;
      parent.append(container);
      entry.remove();
    };
  });

  const enabled$ = writable(enabled);
  $: $enabled$ = enabled;

  function show() {
    if ($enabled$) {
      entry.show();
    }
  }

  function hide() {
    entry.hide();
  }

  const all = {
    anchor: true,
    focus: true,
    mouse: true,
    label: true,
  };
  const tooltip = (element, {
    anchor,
    focus,
    mouse,
    label,
  } = all) => {
    if (anchor) {
      $anchor$ = element;
    }
    if (mouse) {
      element.addEventListener('mouseover', show);
      element.addEventListener('mouseout', hide);
    }
    if (focus) {
      element.addEventListener('focus', show);
      element.addEventListener('blur', hide);
    }
    if (label) {
      enabled$.subscribe((value) => {
        if (value) {
          element.setAttribute('aria-labelledby', tooltipid);
        } else {
          element.removeAttribute('aria-labelledby');
        }
      });
    }
  };
</script>

<slot {tooltip} />

{#if browser}
  <div class='tooltip-content' class:mounted bind:this={container} data-cy={testid} id={tooltipid}>
    <slot name='tooltip' />
  </div>
{/if}

<style>
  .tooltip-content:not(.mounted) {
    display: none;
  }
</style>
